/**
 * Entscheidet, ob die App einen Link-Klick selbst als Seitennavigation (SPA) behandeln soll.
 *
 * Nur ein einfacher Linksklick ohne Zusatztaste gehört der App. Strg/Cmd (neuer Tab), Umschalt (neues Fenster),
 * Alt (Download), Mittel- und Rechtsklick sowie bereits behandelte Ereignisse bleiben beim Browser, damit
 * Links wie echte Links funktionieren (neuer Tab, Link kopieren, Teilen).
 *
 * @param {{ button?: number | null, metaKey?: boolean, ctrlKey?: boolean, shiftKey?: boolean, altKey?: boolean, defaultPrevented?: boolean } | null | undefined} event
 * @returns {boolean}
 */
export function isPlainLeftClick(event) {
  if (!event) return false;
  if (event.defaultPrevented) return false;
  if (event.button !== undefined && event.button !== null && event.button !== 0) return false;
  return !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey);
}
